module.exports = __webpack_public_path__ + "static/media/br-ce.e5240a6f.svg";